import React from 'react';
import { Badge } from '../ui/badge';
import { Award, Medal, Shield, HelpCircle } from 'lucide-react';
import { QUALITY_TIERS } from '../../constants/importConstants';

const tierIcons = {
  4: Award,
  3: Medal,
  2: Shield,
  1: HelpCircle,
};

const tierColors = {
  4: 'bg-success/10 text-success border-success/30',
  3: 'bg-info/10 text-info border-info/30',
  2: 'bg-warning/10 text-warning border-warning/30',
  1: 'bg-muted text-muted-foreground border-border',
};

/**
 * Renders a quality tier badge with icon and label.
 * @param {object} props
 * @param {number} props.level - quality level 1-4
 * @param {boolean} [props.showIcon=true]
 * @param {string} [props.size='default'] - 'sm' | 'default'
 * @param {string} [props.className]
 */
const QualityTierBadge = ({ level, showIcon = true, size = 'default', className = '' }) => {
  const tier = QUALITY_TIERS[level];
  if (!tier) return null;

  const Icon = tierIcons[level];
  const colorClass = tierColors[level] || tierColors[1];
  const sizeClass = size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-xs px-2 py-1';

  return (
    <Badge className={`${colorClass} border ${sizeClass} font-medium gap-1 ${className}`}>
      {showIcon && Icon && <Icon size={size === 'sm' ? 10 : 12} strokeWidth={1.5} />}
      {tier.label}
    </Badge>
  );
};

export default QualityTierBadge;
